<div class="container">
    <mat-card>
        <h2 mat-title>Faltantantes/Sobrantes</h2>
        <form [formGroup]="cashDifferenceForm" (ngSubmit)="submit()">
            <mat-card-content fxLayout="column">
                <mat-form-field fxFlex="48%" (click)="cashDatePicker.open()">
                    <mat-label>Fecha</mat-label>
                    <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="cashDatePicker" required
                        formControlName="txnDate">
                    <mat-datepicker-toggle matSuffix [for]="cashDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #cashDatePicker></mat-datepicker>
                    <mat-error *ngIf="cashDifferenceForm.controls.txnDate.hasError('required')">
                        Fecha <strong>es obligatoria</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Transacción</mat-label>
                    <mat-select formControlName="transactionType" required>
                        <mat-option *ngFor="let tran of transactionTypeOptions" [value]="tran.value">
                            {{ tran.displayName }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="cashDifferenceForm.controls.transactionType.hasError('required')">
                        Transacción <strong>es obligatoria</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Moneda</mat-label>
                    <mat-select formControlName="currencyCode" required>
                        <mat-option *ngFor="let curr of currencyOptions.selectedCurrencyOptions" [value]="curr.code">
                            ({{ curr.code }}) {{ curr.displayLabel }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="cashDifferenceForm.controls.currencyCode.hasError('required')">
                        Moneda <strong>es obligatoria</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Monto</mat-label>
                    <input type="number" formControlName="amount" required matInput />
                    <mat-error *ngIf="cashDifferenceForm.controls.amount.hasError('required')">
                        Monto <strong>es obligatorio</strong>
                    </mat-error>
                </mat-form-field>
                <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
                    <button type="button" mat-raised-button [routerLink]="['/home']">Cancelar</button>
                    <button mat-raised-button color="primary" [disabled]="!cashDifferenceForm.valid">Ajustar las diferencias</button>
                </mat-card-actions>
            </mat-card-content>
        </form>
    </mat-card>
</div>